import client from '../../../core/api/client';

export const getDashboard = () => client.get('/admin/dashboard');
